// ann ugly hack for https://github.com/testing-library/react-testing-library/issues/470 until fixed
export const isMuted = true